import { Input, InputProps } from 'antd';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { OrderContext } from '~/App/Layout/providers/OrderProvider';
import { UserOutlined } from '@ant-design/icons';
import i18n from '~/i18n';
import './style.css';

const debounce = (func: any) => {
  let timer: NodeJS.Timeout | null = null;
  return (arg: any) => {
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
    timer = setTimeout(() => {
      func(arg);
    }, 500);
  };
};

const InputCustomerName = () => {
  const { order, setOrder } = useContext(OrderContext);
  const [value, setValue] = useState(order.customerName ?? undefined);

  const setOrderDebounced = useRef(debounce(setOrder));

  const onChange: InputProps['onChange'] = (event) => {
    const val = event.target.value;
    setValue(val);
    setOrderDebounced.current({
      ...order,
      customerName: val,
    });
  };
  const name = order.customerName;
  const disabled = !order.isNew;

  useEffect(() => {
    setValue(name ? name : undefined);
  }, [name]);

  return (
    <Input
      onChange={onChange}
      value={value}
      placeholder={i18n.t('order_info_name')}
      prefix={<UserOutlined />}
      bordered={false}
      className={`w-100 h-8	${
        disabled ? 'input-disabled' : 'input-enabled input-customer-name'
      }`}
      disabled={disabled}
    />
  );
};

export default InputCustomerName;
